// extracted by mini-css-extract-plugin
export var infoItem = "_r3-2";
export var title = "_r3-0";
export var value = "_r3-1";